import { Box, Divider, Grid, makeStyles, Typography } from '@material-ui/core';
import { isEmpty } from 'lodash';
import { useObserver } from 'mobx-react-lite';
import React, { FC, Fragment } from 'react';
import OrderItem from './OrderItem';
import { LayoutVariant } from '../../Core/CommonTypes';
import { OnlineOrder, OrderItem as OI, Promotion } from 'kiolyn-api';
import OrderSummary from './OrderSummary';
import AvailablePromotions from './AvailablePromotions';

const useStyles = makeStyles(() => ({
  container: {
    height: '100%',
    flexWrap: 'nowrap'
  },
  items: {
    flex: '1 1 auto',
    overflowY: 'auto'
  },
  kiosk_items: {
    height: '50%',
    overflowY: 'auto'
  },
  emptyPrompt: {
    width: '80%',
    textAlign: 'center',
    margin: 'auto',
    fontWeight: 500
  },
  orderItem: {
    marginBottom: 4
  }
}));

interface OrderDetailProps {
  order: OnlineOrder;
  onDeleteItem?: (orderItem: OI) => void;
  onEditItem?: (orderItem: OI) => void;
  onItemChange?: (orderItem: OI) => void;
  promotions?: Promotion[];
  onApplyCheapestPromotion?: (promotion: Promotion) => void;
  variant?: LayoutVariant;
}

const OrderDetail: FC<OrderDetailProps> = ({
  order,
  promotions,
  onApplyCheapestPromotion,
  variant,
  ...actions
}: OrderDetailProps) => {
  const classes = useStyles();
  return (
    <Grid container className={classes.container} direction="column">
      <Grid
        item
        className={
          variant === LayoutVariant.kiosk ? classes.kiosk_items : classes.items
        }
      >
        {isEmpty(order.items) ? (
          <Typography color="textSecondary" className={classes.emptyPrompt}>
            {variant === LayoutVariant.mobile
              ? 'Your order is empty.'
              : 'Start ordering by selecting your item on the left menu.'}
          </Typography>
        ) : (
          <Fragment>
            {promotions && (
              <AvailablePromotions
                promotions={promotions}
                onApplyCheapestPromotion={onApplyCheapestPromotion}
              />
            )}
            <OrderItems order={order} {...actions} />
          </Fragment>
        )}
      </Grid>
      <Grid item>
        <Divider />
        <OrderSummary order={order} />
      </Grid>
    </Grid>
  );
};

export default OrderDetail;

interface OrderItemsProps {
  order: OnlineOrder;
  onDeleteItem?: (orderItem: OI) => void;
  onEditItem?: (orderItem: OI) => void;
  onItemChange?: (orderItem: OI) => void;
}

const OrderItems: FC<OrderItemsProps> = ({
  order,
  onDeleteItem,
  onEditItem,
  onItemChange
}: OrderItemsProps) => {
  const classes = useStyles();
  return useObserver(() => (
    <Fragment>
      {order.items.map(orderItem => (
        <Box key={orderItem.id} className={classes.orderItem}>
          <OrderItem
            key={orderItem.id}
            orderItem={orderItem}
            onDelete={onDeleteItem}
            onEdit={onEditItem}
            onChange={onItemChange}
          />
          <Divider />
        </Box>
      ))}
    </Fragment>
  ));
};
